import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "page-title d-flex flex-column align-items-start justify-content-center flex-wrap me-2 mb-5 mb-lg-0",
  "data-kt-swapper": "true",
  "data-kt-swapper-mode": "prepend",
  "data-kt-swapper-parent": "{default: '#kt_content_container', lg: '#kt_header_container'}"
}
const _hoisted_2 = { class: "text-dark fw-bolder mt-1 mb-1 fs-2" }
const _hoisted_3 = {
  key: 0,
  class: "breadcrumb fw-bold fs-base mb-1"
}
const _hoisted_4 = { class: "breadcrumb-item text-muted" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Home")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
    (_ctx.breadcrumbs)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/dashboard",
              class: "text-muted text-hover-primary"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (item, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              class: _normalizeClass(`breadcrumb-item ${
            i === _ctx.breadcrumbs.length - 1 ? 'text-dark' : 'text-muted'
          }`)
            }, _toDisplayString(item), 3))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}